import { connect } from 'react-redux';
import AnnualBudget from './components/AnnualBudget';

const mapStateToProps = (state) => ({
  agencyId: state.auth.profile.extend.agency.id
});

export default connect(mapStateToProps)(AnnualBudget);
